import ApiClient from "./ApiClient";

export default class DocumentApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "documents/";

  constructor() {
    this.apiClient = new ApiClient();
  }


  async uploadStudentPdf(file: File, financingRequestStudentDataId: number, financingRequestId: number) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("financingRequestStudentDataId", financingRequestStudentDataId.toString());
    formData.append("financingRequestId", financingRequestId.toString());

    const response = await this.apiClient.post(this.urlPrefix + "student/upload", formData);
    return response;
  }

  async downloadStudentPdf(documentId: number, fileName: string) {
    const response = await this.apiClient.download(this.urlPrefix + `student/download/${documentId}`, "get", null, fileName);
    return response;
  }

  async deleteStudentPdf(documentId: number) {
    const response = await this.apiClient.delete(this.urlPrefix + `student/delete/${documentId}`);
    return response;
  }

  async uploadDecisionPdf(file: File, financingRequestId: number) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("financingRequestId", financingRequestId.toString());

    const response = await this.apiClient.post(this.urlPrefix + "decision/upload", formData);
    return response;
  }

  async downloadDecisionPdf(documentId: number, fileName: string) {
    const response = await this.apiClient.download(this.urlPrefix + `decision/download/${documentId}`, "get", null, fileName);
    return response;
  }

  async deleteDecisionPdf(documentId: number) {
    const response = await this.apiClient.delete(this.urlPrefix + `decision/delete/${documentId}`);
    return response;
  }

  async uploadSchoolCarrierPdf(file: File, financingRequestId: number, schoolCarrierId: number) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("financingRequestId", financingRequestId.toString());
    formData.append("schoolCarrierId", schoolCarrierId.toString());

    const response = await this.apiClient.post(this.urlPrefix + "schoolCarrier/upload", formData);
    return response;
  }

  async downloadSchoolCarrierPdf(documentId: number, fileName: string) {
    const response = await this.apiClient.download(this.urlPrefix + `schoolCarrier/download/${documentId}`, "get", null, fileName);
    return response;
  }

  async deleteSchoolCarrierPdf(documentId: number) {
    const response = await this.apiClient.delete(this.urlPrefix + `schoolCarrier/delete/${documentId}`);
    return response;
  }

  async uploadAuthorizedCarrierPdf(file: File, financingRequestId: number, authorizedCarrierId: number) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("financingRequestId", financingRequestId.toString());
    formData.append("authorizedCarrierId", authorizedCarrierId.toString());

    const response = await this.apiClient.post(this.urlPrefix + "authorizedCarrier/upload", formData);
    return response;
  }

  async downloadAuthorizedCarrierPdf(documentId: number, fileName: string) {
    const response = await this.apiClient.download(this.urlPrefix + `authorizedCarrier/download/${documentId}`, "get", null, fileName);
    return response;
  }

  async deleteAuthorizedCarrierPdf(documentId: number) {
    const response = await this.apiClient.delete(this.urlPrefix + `authorizedCarrier/delete/${documentId}`);
    return response;
  }
}
